<div class="loader-overlay" [style.display]="isLoading ? 'block' : 'none'">
  <div class="loader-container">
    <div class="loader">
      <ng-container [ngSwitch]="loaderType">
        <h1 *ngSwitchCase="LoaderType.Loading">{{ loadingText }}</h1>
        <div class="circular" *ngSwitchCase="LoaderType.Circular"></div>
      </ng-container>
    </div>
  </div>
</div>
